var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAttributes = function SvgAttributes(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#6C6C89",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M6.664 10h.008m3.322 0H10m3.322 0h.008M15 17.5c1.027 0 1.86-.96 1.86-2.143 0-1.873-.084-3.118 1.201-4.6a1.19 1.19 0 0 0 0-1.515c-1.285-1.48-1.202-2.726-1.202-4.6C16.86 3.46 16.027 2.5 15 2.5M4.997 17.5c-1.026 0-1.859-.96-1.859-2.143 0-1.873.083-3.118-1.202-4.6a1.19 1.19 0 0 1 0-1.515c1.257-1.448 1.202-2.709 1.202-4.6 0-1.183.833-2.142 1.86-2.142"
  })));
};
export default SvgAttributes;